import { Core } from '@walletconnect/core';
import { Web3Wallet } from '@walletconnect/web3wallet';
import QRCode from 'qrcode';

// Configure your WalletConnect project
// Replace this with your actual project ID from WalletConnect Cloud
const projectId = 'YOUR_PROJECT_ID';

// Initialize wallet connect client
export const initWalletConnectProvider = async () => {
  try {
    // Initialize the Core
    const core = new Core({
      projectId,
    });

    // Initialize the Web3Wallet
    const web3wallet = await Web3Wallet.init({
      core,
      metadata: {
        name: 'My Wallet App',
        description: 'Demo wallet app using WalletConnect',
        url: 'https://mywebsite.com',
        icons: ['https://walletconnect.com/walletconnect-logo.png']
      }
    });
    
    return web3wallet;
  } catch (error) {
    console.error('Error initializing WalletConnect provider:', error);
    throw error;
  }
};

// Generate QR code data URL from WalletConnect URI
export const generateQrCodeFromUri = async (uri) => {
  try {
    // Generate QR code as data URL with reduced size (200x200)
    const dataUrl = await QRCode.toDataURL(uri, {
      margin: 2,
      width: 200, // Reduced from 300 to 200
      color: {
        dark: '#000000',
        light: '#ffffff'
      },
      errorCorrectionLevel: 'H', // Higher error correction for logo overlay
      rendererOpts: {
        quality: 1.0
      }
    });
    return dataUrl;
  } catch (error) {
    console.error('Error generating QR code:', error);
    throw error;
  }
}; 